import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "@/lib/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "Doctrine" },
  { to: "/partners", label: "Partners" },
  { to: "/donate", label: "Support" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 border-b border-slate-200 bg-[#FAF7EC]/95 backdrop-blur supports-[backdrop-filter]:bg-[#FAF7EC]/80"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 md:px-12 lg:px-16 h-20 md:h-24">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-3 group"
          onClick={() => setOpen(false)}
        >
          <img
            src="/logo.png"
            alt="Midnight Sun Working Dog Coalition"
            className="h-16 md:h-20 w-auto object-contain"
          />
          <span className="sr-only">Midnight Sun Working Dog Coalition</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 lg:gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-[11px] uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-amber-600" : "text-slate-700 hover:text-slate-900"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/donate"
            data-testid="nav-donate-cta"
            className="bg-amber-600 hover:bg-amber-700 text-white px-5 py-3 font-semibold text-sm transition-colors flex items-center gap-2"
          >
            Donate
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-[#FAF7EC]">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 font-mono text-xs uppercase tracking-[0.18em] border-b border-slate-200 ${
                    isActive ? "text-amber-600" : "text-slate-800"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              data-testid="nav-mobile-donate"
              onClick={() => setOpen(false)}
              className="mt-3 bg-amber-600 text-white text-center py-3 font-semibold text-sm"
            >
              Donate
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
